import { $admin } from "./api/admin";
import apiEndpoints from "@/constants/api-endpoints";

/**
 * Fetches list of customers of a user has owner access
 * @param {String} userId id of user whose customer accounts access are to be
 * @returns {Array} List of customers
 */
export const getCustomerOwners = (userId, params) => {
  return $admin.get(
    `${apiEndpoints.customers}/${userId}${apiEndpoints.owners}`,
    { params }
  );
};

/**
 * Add a new customer owner access to a user
 * @param {String} userId id of the user whom to provider owner access
 * @returns {Promise} Details and status representing newly added customer owner tole
 */
export const addCustomerOwner = (userId, payload) => {
  const endpoint = `${apiEndpoints.customers}/${userId}${apiEndpoints.owners}`;
  return $admin.post(endpoint, payload);
};

/**
 * Deletes a customer owner access given to a user
 * @param {String} userId id of the user whom to provider owner access
 * @param {String} id Id of user customer record to be deleted
 * @returns {Promise} Details and status representing newly added customer owner tole
 */
export const deleteCustomerOwner = (userId, id) => {
  return $admin.delete(
    `${apiEndpoints.customers}/${userId}${apiEndpoints.owners}/${id}`
  );
};
